export class Registry<T> {
  private items = new Map<number, T>();
  private counter = 0;

  /**
   * Registers an item, returns its numeric ID.
   */
  register(item: T): number {
    const id = this.counter;
    this.items.set(id, item);
    this.counter = this.counter + 1;
    return id;
  }

  /**
   * Registers an item, returns its numeric ID.
   */
  deregister(id: number): boolean {
    return this.items.delete(id);
  }

  deregisterAll(): void {
    this.items.clear();
  }

  /**
   * Retrieves a previously-registered item by ID.
   */
  get(id: number): T | undefined {
    return this.items.get(id);
  }

  get size(): number {
    return this.items.size;
  }

  getAny(): T | undefined {
    return this.items.values().next().value;
  }
}
